import { app } from '../../../bootstrap/core';
import { navbarComponent } from './navbar.component';
import { NavbarService } from './navbar.service';
import {
  ReceivingTab,
  TransferringTab,
  InboxTab,
  KWHTab,
  KWSTab,
  DWSTab,
} from './tabs';

app.component('navbar', navbarComponent);
app.service('navbarService', NavbarService);
app.constant('navbarTabs', {
  InboxTab,
  TransferringTab,
  ReceivingTab,
});
app.constant('navbarTabsByProduct', {
  InboxTab,
  KWHTab,
  KWSTab,
  DWSTab,
});
